<template>
  <svg
    :class="{
      'text-www-color-accent': true,
    }"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.825 3.24756L4.87129 9.20131L2.16504 6.49506"
      stroke="currentColor"
      stroke-width="1.62375"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
